

export default function mergeDeep(target, source) {
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            const value = source[key];
            // If both target and source values are objects, recurse into the objects
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                if (!target[key]) {
                    target[key] = {}; // Create an empty object if it doesn't exist
                }
                mergeDeep(target[key], value);
            } else {
                // Otherwise, assign the value from the source to the target
                target[key] = value;
            }
        }
    }
    return target;
}